import React from "react";
import { Typography, Divider } from "@mui/material";
import { info } from "../helpers/Info";
import BomberosItem from "../components/BomberosItem";
import "../styles/Seguridad.css";
import { isMobile } from "react-device-detect";
import ContactForm from "../components/ContactForm";

const Bomberos = () => {
  return (
    <div className="seguridad">
      <div
        style={{
          backgroundColor: "#6699ff",
          padding: ".5rem",
          marginBottom: "2rem",
          color: "#fafafa",
     
        }}
      >
        {" "}
        <div
          style={{
            width: isMobile ? "80%" : "96%",
            margin: "0 auto",
          }}
        >
          <Typography variant="h1">Ingeniería contra incendios </Typography>
          <Typography variant="h3">
            Diseñamos la solución específica para tu proyecto de manera integral
            por profesionales altamente calificados
          </Typography>
        </div>
      </div>
      <div
        style={{
          width: isMobile ? "100%" : "80%",
          margin: "0 auto",
          marginBottom: "2rem",
        }}
      >
        <Typography component="div" variant="h6">
          SERVICIOS
        </Typography>
      </div>

      <div
        style={{
          width: isMobile ? "100%" : "80%",
          margin: "0 auto",
          paddingBottom: "3rem",
        }}
      >
        {info.map((item) => {
          return (
            item.id === 1 &&
            item.servicios.map((serv) => {
              return <BomberosItem key={serv.id} serv={serv} />;
            })
          );
        })}
      </div>
      <Divider />
      <ContactForm placeholder="Información de utilidad: uso del local, superficie en m2, dirección y localidad" id="bomberos" />
    </div>
  );
};

export default Bomberos;
